import { AxiosHeaders, type AxiosInstance } from "axios";
import i18next from "i18next";

export const useLanguageInterceptor = (instance: AxiosInstance) => {
	instance.interceptors.request.use((req) => {
		const locale = localStorage.getItem("locale") || i18next.language;

		if (!req.headers) req.headers = new AxiosHeaders();
		if (locale) req.headers["Accept-Language"] = locale;

		return req;
	});
};
